(function () {
  function loadAsyncCSS() {
    const preloadLinks = document.querySelectorAll('link[rel="preload"][as="style"]');
    preloadLinks.forEach(link => {
      const stylesheet = document.createElement('link');
      stylesheet.rel = 'stylesheet';
      stylesheet.href = link.href;
      stylesheet.media = link.media || 'all';
      link.parentNode.insertBefore(stylesheet, link.nextSibling);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadAsyncCSS);
  } else {
    loadAsyncCSS();
  }
})();
